import React, { Component } from 'react';
import styled, { css } from 'react-emotion';
import { Transition } from 'react-transition-group'; // ES6
import c from 'classnames';
import $j from 'jquery';

import { hideIntercomWidget } from 'components/IntercomInit/hideShowWidget';
import { hideLiveClassActionBtns } from 'components/LiveClass/model-views/LocalUserMedia/hideLiveClassActionBtns';

import ReactMediaPlayer from '../../../../components/ReactMediaPlayer/ReactMediaPlayer';
import Icon from '../../../../helper/Icon';
import WindowScrollHandler from '../../../helper/WindowScrollHandler';

import './index.css';
// import Relay from 'react-relay';

const StickyNarrationPlayerContainer = css`
  position: relative;
  // padding: 0px 0px 0px 0px;
  height: 68px;
`;

const StickyNarratButton = styled.div`
  float: right;
  background-color: #fff;
  border: 1px solid var(--color-grey1);
  border-radius: 50%;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);
  height: 60px;
  width: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const transitionStyles = {
  entering: { bottom: '-80px', transition: 'bottom 0.3s ease' },
  entered: { bottom: '0px', transition: 'bottom 0.3s ease' },
  exiting: { bottom: '-80px', transition: 'bottom 0.3s ease' }
};

class StickyNarrationPlayer extends Component {
  renderReactMediaPlayer = () => (
    <ReactMediaPlayer
      autoPlay={true}
      src={this.props.narrationUrl}
      onClose={this.props.handleMobileNarratClick}
      showClose={true}
    />
  );

  buttonClass = '';
  playerClass = '';

  componentDidMount() {
    this.button = $j('.stickyNarratButton');
    this.buttonContainer = $j('.stickyButtonContainer');
    this.playerContainer = $j('.stickyPlayerContainer');
    WindowScrollHandler.addCallbackObj(
      this.windowScrollCallback.bind(window, this),
      'mobileNarrationPlayer'
    );
    setTimeout(() => this.windowScrollCallback(this), 100);
  }

  windowScrollCallback(component) {
    const self = component;
    const buttonContainerBottom = self.buttonContainer.offset().top + self.buttonContainer.height();
    const btnBottom = self.button.offset().top + self.button.outerHeight();
    const btnRect = self.button[0].getBoundingClientRect();
    const buttonHeightAndPadding = 60 + 18;
    if (
      btnRect.y + buttonHeightAndPadding > window.innerHeight
      && self.buttonClass.indexOf('sticky') < 0
    ) {
      self.button.addClass('sticky');
      self.buttonClass = ' sticky';
    } else if (buttonContainerBottom <= btnBottom && self.buttonClass.indexOf('sticky') > -1) {
      self.button.removeClass('sticky');
      self.buttonClass = '';
    }

    const playerContainerBottom = self.playerContainer.offset().top + self.playerContainer.height();
    // console.log('true:: ', (!self.player || self.player.length === 0) && self.props.showNarration);
    if (
      (!self.player
        || self.player.length === 0
        || self.player[0].getBoundingClientRect().y === 0)
      && self.props.showNarration
    ) {
      self.player = $j('.stickyNarrationPlayerContainer');
    }
    if (self.player && self.player.length === 1) {
      const playerBottom = self.player.offset().top + self.player.outerHeight();
      const playerRect = self.player[0].getBoundingClientRect();
      if (playerRect.y + 56 > window.innerHeight) {
        self.player.addClass('sticky');
        self.playerClass = ' sticky';
      } else if (playerContainerBottom <= playerBottom) {
        self.player.removeClass('sticky');
        self.playerClass = '';
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.cardId !== this.props.cardId
      || this.props.showNarration !== prevProps.showNarration
    ) {
      setTimeout(() => {
        this.player = $j('.stickyNarrationPlayerContainer');
        this.windowScrollCallback(this);
      }, 400);

      // INTERCOM:: Intercom widget hide/show based on narration player visibility
      if (this.props.showNarration) {
        hideIntercomWidget(true);
        hideLiveClassActionBtns(true);
      }
      if (!this.props.showNarration) {
        hideIntercomWidget(false);
        hideLiveClassActionBtns(false);
      }
    }
    // this.player = $j('.stickyNarrationPlayerContainer');
    // this.container = $j('.StickyPlayerContainer');
  }

  componentWillUnmount() {
    this.props.handleMobileNarratClick(false);

    // INTERCOM:: Intercom widget hide/show based on narration player visibility
    hideIntercomWidget(false);

    WindowScrollHandler.removeCallbackObj('mobileNarrationPlayer');
  }

  render() {
    return (
      <div className={StickyNarrationPlayerContainer + ' StickyPlayerContainer'}>
        <div className="stickyButtonContainer">
          {this.props.narrationUrl && this.props.show ? (
            <StickyNarratButton
              role="presentation"
              className={c(
                'stickyNarratButton',
                { active: this.props.showNarration },
                this.buttonClass
              )}
              onClick={this.props.handleMobileNarratClick}
            >
              <Icon
                icon="headset"
                fill={this.props.showNarration ? 'rgb(10, 191, 241)' : 'rgba(37, 51, 66, 0.298039)'}
                size="2em"
              />
            </StickyNarratButton>
          ) : null}
        </div>
        <div className="stickyPlayerContainer">
          <Transition
            className="rs-media-player"
            timeout={300}
            in={this.props.narrationUrl && this.props.showNarration}
          >
            {state => (state === 'exited' ? null : (
              <div
                className="stickyNarrationPlayerContainer"
                style={{
                  ...transitionStyles[state]
                }}
              >
                {this.renderReactMediaPlayer()}
              </div>
            ))
            }
          </Transition>
        </div>
      </div>
    );
  }
}

export default StickyNarrationPlayer;
